import { DataProviderProxy, fetchUtils } from "react-admin";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ONEMAP_API_URL } from "./const";
import axios from "axios";
import polyUtil from "polyline-encoded";

export const getUser = () => {
  return {
    user: {
      authenticated: true,
      token: `Bearer ${localStorage.getItem("token")}`,
    },
  };
};

export const colors = [
  "#016a02",
  "#011f03",
  "#2196f3",
  "#3f51b5",
  "#00bcd4",
  "#f44336",
  "#e91e63",
  "#9c27b0",
  "#ffc107",
];

export const httpClient = fetchUtils.fetchJson;

export const getDataFromJson = (url: string): Promise<any> => {
  return httpClient(url)
    .then(({ json, status }: any) => {
      return { json, status };
    })
    .catch((error: any) => console.log(error));
};

export const GetParam = () => {
  return new URLSearchParams(useLocation().search);
};

export const AcademicYearResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.academicYears?.data[id],
  );

  return data;
};

export const CcaAcademicYearResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.ccaAcademicYears?.data[id],
  );
  return data;
};

export const AcademicTermResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.academicTerms.data[id],
  );

  return data;
};

export const CcaAcademicTermResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.ccaAcademicTerms.data[id],
  );

  return data;
};

export const CcaFixedLocationDropOffResources = (id: number) => {
  const data = useSelector(
    (resource: any) =>
      resource.admin.resources.ccaFixedLocationDropOffs.data[id],
  );

  return data;
};

export const StudentResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.students.data[id],
  );

  return data;
};

export const ParentResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.parents.data[id],
  );

  return data;
};

export const CompanyResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.companies.data[id],
  );

  return data;
};

export const PersonInChargeResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.personInCharges.data[id],
  );
  return data;
};

export const SchoolIdSelected = () => {
  const data = useSelector(({ navMode }: any) => navMode.school?.id);

  return data;
};

export const SchoolResourceSelected = () => {
  const data = useSelector(({ navMode }: any) => navMode.school);

  return data;
};

export const BusSchedulePlanResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.busSchedulePlans.data[id],
  );

  return data;
};

export const BusScheduleResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.busSchedules.data[id],
  );

  return data;
};

export const UserResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.users.data[id],
  );

  return data;
};

export const LevelResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.levels.data[id],
  );

  return data;
};

export const getAddressFromCoordinates = async (coordinates: any) => {
  const url = `${ONEMAP_API_URL}/public/revgeocode?location=${coordinates.lat},${coordinates.lng}&buffer=40&addressType=All&otherFeatures=N`;

  try {
    const address = await axios.get(url);

    return address.data;
  } catch (e) {
    throw e;
  }
};

export const getRouteService = async (
  startCoordinate: any,
  endCoordinate: any,
): Promise<any> => {
  const start = `${startCoordinate.lat},${startCoordinate.lng}`;
  const end = `${endCoordinate.lat},${endCoordinate.lng}`;
  const url = `${ONEMAP_API_URL}/public/routingsvc/route?start=${start}&end=${end}&routeType=drive`;

  try {
    const config = {
      // Prevent Axios from throwing errors for 401 and 429 status
      validateStatus: (status: number) =>
        (status >= 200 && status < 400) || status === 401 || status === 429,
    };

    const response = await axios.get(url, config);

    if (response.status === 429) {
      await delay(2000);

      return getRouteService(startCoordinate, endCoordinate);
    }

    // Process the successful response
    const decode = decodeRoute(response.data.route_geometry);
    const totalTime = response.data.route_summary.total_time; // in seconds

    return {
      routePolyline: decode,
      totalTime: totalTime,
      routeGeometry: response.data.route_geometry,
    };
  } catch (e) {
    throw e;
  }
};

export const decodeRoute = (geometry: string) => {
  if (geometry !== undefined || geometry !== "" || geometry !== null) {
    let latLngs = polyUtil.decode(geometry, {
      precision: 5,
    });

    let results: any = [];

    latLngs.forEach((decodeRoute: any) => {
      let result = { lat: decodeRoute[0], lng: decodeRoute[1] };

      results.push(result);
    });

    return results;
  }
};

export const encodeRoutes = (routes: any[]) => {
  let results: any = [];

  routes.forEach((route: any) => {
    let result = [route.lat, route.lng];

    results.push(result);
  });

  return polyUtil.encode(results, 5);
};

export const sumCentsAmountToDolar = (datas: IResultCalculationItem[]) => {
  return (datas.reduce((a: number, b: any) => a + b.total, 0) / 100).toFixed(2);
};

export const availableOnlySuperAdminAndAdminAndFinance = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  return (
    roles.includes("superadmin") ||
    roles.includes("admin") ||
    roles.includes("finance")
  );
};

export const getCustomerType = (type: string) => {
  switch (type) {
    case "parent":
      return "parent";
    case "company_person_in_charge":
      return "person in charge";
    default:
      break;
  }
};

export const getResourceByCustomerType = (type: string) => {
  switch (type) {
    case "parent":
      return "parents";
    case "company_person_in_charge":
      return "personInCharges";
    default:
      break;
  }
};

export const delay = (ms: number) => {
  return new Promise((res) => setTimeout(res, ms));
};

export const capitalizeFirstLetter = (string: string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : null;
};

export const meterToKilometer = (distance: number) => {
  return distance / 1000;
};

export const getAssignmentWithVehicleLocation = async (
  provider: DataProviderProxy,
  schoolId: number,
) => {
  let allAssignments: IAssignmentWithVehicleLocation[] = [];
  let assignmentsData: any;

  let page = 1;
  do {
    try {
      // Use await to handle the promise and catch errors
      assignmentsData = await provider
        .getList("assignmentsWithVehicleLocation", {
          filter: { Status: "started", SchoolId: schoolId },
          pagination: {
            page: page,
            perPage: 50,
          },
          sort: {
            field: "Id",
            order: "ASC",
          },
        })
        .then((result: any) => result.data);

      // get all assignments based on assignmentsDataIds to get school data and route name
      const assignmentsDataIds = assignmentsData.map(
        (assignmentData: IAssignmentWithVehicleLocation) => assignmentData.id,
      );
      const assignments = await provider
        .getMany("assignments", {
          ids: assignmentsDataIds,
        })
        .then((result: any) => {
          return result.data;
        });

      // mapping assignmentsData with assignments
      assignmentsData = assignmentsData.map(
        (assignmentData: IAssignmentWithVehicleLocation) => {
          const findAssignment = assignments.find(
            (assignment: IAssignment) => assignment.id === assignmentData.id,
          );

          return {
            routeName: findAssignment?.routeName,
            school: findAssignment?.school,
            ...assignmentData,
          };
        },
      );

      allAssignments = [...allAssignments, ...assignmentsData];

      page++;
    } catch (error) {
      throw error; // Re-throw the error if needed
    }
  } while (assignmentsData.length > 0);

  return allAssignments;
};

export const getUserIdFilterBasedOnRole = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  const rolesFiltered = ["admin", "school"];
  let filter = {};

  if (roles.some((role) => rolesFiltered.includes(role))) {
    filter = { UserId: Number(localStorage.getItem("userId")) };
  }

  return filter;
};

export function isNumber(n: number) {
  return !isNaN(n - 0);
}

export const getMonth = (month: number) => {
  switch (month) {
    case 1:
      return "January";
    case 2:
      return "February";
    case 3:
      return "March";
    case 4:
      return "April";
    case 5:
      return "May";
    case 6:
      return "June";
    case 7:
      return "July";
    case 8:
      return "August";
    case 9:
      return "September";
    case 10:
      return "October";
    case 11:
      return "November";
    case 12:
      return "December";
    default:
      return "";
  }
};

export const capitalizeWords = (input: string) => {
  if (!input) return "";

  return input
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const toDateOnly = (dateInput: string | Date) => {
  const d = new Date(dateInput);
  d.setHours(0, 0, 0, 0); // normalize to date-only
  return d;
}
